import { isNull } from 'lodash-es'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { useRouter } from '@/shared/i18n'

const CATEGORY_PARAM = 'categoryId'

export const useCategory = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const categoryIdFromParams = searchParams?.get(CATEGORY_PARAM)

  const [selectedCategory, setSelectedCategory] = useState<number | null>(null)

  const handleChange =
    (id: number | null, replace = false) =>
    () => {
      const params = new URLSearchParams(searchParams?.toString() ?? '')

      params.delete('page')

      if (isNull(id)) {
        params.delete(CATEGORY_PARAM)
        setSelectedCategory(null)
      } else {
        params.set(CATEGORY_PARAM, id.toString())
        setSelectedCategory(id)
      }

      if (replace) {
        router.replace(`?${params.toString()}`)
      } else {
        router.push(`?${params.toString()}`)
      }
    }

  useEffect(() => {
    setSelectedCategory(
      categoryIdFromParams ? Number(categoryIdFromParams) : null,
    )
  }, [categoryIdFromParams])

  return {
    selectedCategory,
    handleCategoryChange: handleChange,
  }
}
